    window.onload = function(){
    const compareCountries = document.querySelectorAll('.compare__countries')

    function setEqualHeight(figures) {
        let maxHeight = 0

        figures.forEach((figure) => {
            figure.style.height = 'auto' // Reset the height to auto to recalculate
            const figureHeight = figure.clientHeight
            maxHeight = Math.max(maxHeight, figureHeight) // compare the heights and get the highest
        })

        // Set the height
        figures.forEach((figure) => {
            figure.style.height = `${maxHeight}px`
        })
    }

    compareCountries.forEach((element) => {
        const figures = element.querySelectorAll('.compare__figure')
        setEqualHeight(figures)
    })

    // Add a resize event listener to recalculate heights when the screen resizes
    window.addEventListener("resize", function () {
        compareCountries.forEach((element) => {
            const figures = element.querySelectorAll('.compare__figure')
            setEqualHeight(figures)
        })
    })
}
